module.exports = __webpack_public_path__ + "images/babboe_small7bc0944bd9f6c8dfb5ad3ccfb62cfdce.png";